import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, TextField} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import moment from 'moment'
import { useAlert } from "react-alert";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    }
}));

const screenCode = 'ITEMREQUISITION';

export default function RequisitionListing(props) {

    const classes = useStyles();
    const navigate = useNavigate();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [isShowTable, setIsShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
    const [warehouse, setWarehouse] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [statusCodes, setStatusCodes] = useState([]);
    const [isInitialLoadScreen, setIsInitialLoadScreen] = useState(false);

    const alert = useAlert()
    const [requisitionSearchDetails, setRequisitionSearchDetails] = useState({
        groupID: '0',
        factoryID: '0',
        warehouseID: '0',
        budgetCodeID: '0',
        statusID: '0',
    });
    const handleClick = () => {
        encrypted = btoa('0');
        navigate('/app/itemRequisition/addEdit/' + encrypted);
    }

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });

    useEffect(() => {
        trackPromise(getGroupsForDropdown());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropdown(), getBudgetCodeDetails(), getStatusDetails());
    }, [requisitionSearchDetails.groupID]);

    useEffect(() => {
        trackPromise(
            GetWarehousesByGroupIDAndFactoryID()
        );
    }, [requisitionSearchDetails.groupID, requisitionSearchDetails.factoryID])

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('Requisition-listing-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDefaultLoad != null || IDDataForDefaultLoad != undefined) {
            getRequisitionDetails();
        }
    }, [IDDataForDefaultLoad]);

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                factoryID: '0',
                warehouseID: '0',
                budgetCodeID: '0',
                statusID: '0',
            })
        }
    }, [requisitionSearchDetails.groupID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                warehouseID: '0',
                budgetCodeID: '0',
                statusID: '0',
            })
        }
    }, [requisitionSearchDetails.factoryID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                budgetCodeID: '0',
                statusID: '0',
            })
        }
    }, [requisitionSearchDetails.warehouseID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                statusID: '0',
            })
        }
    }, [requisitionSearchDetails.budgetCodeID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setIsShowTable(false);
        }
    }, [requisitionSearchDetails.statusID])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setToDate(new Date());
            setIsShowTable(false);
        }
    }, [fromDate])

    useEffect(() => {
        if (isInitialLoadScreen) {
            setIsShowTable(false);
        }
    }, [toDate])

    useEffect(() => {
        sessionStorage.removeItem('Requisition-listing-page-search-parameters-id');
    }, []);

    async function getPermissions(IDdata) {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWITEMREQUISITION');
        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        const initialValues = IDdata == null;
        if (initialValues) {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: permissionList.isFactoryFilterEnabled ? '0' : (parseInt(tokenService.getFactoryIDFromToken())),
            })
            setIsInitialLoadScreen(true);
        }
        else {
            setRequisitionSearchDetails({
                ...requisitionSearchDetails,
                groupID: parseInt(IDdata?.groupID),
                factoryID: parseInt(IDdata?.factoryID),
                warehouseID: parseInt(IDdata?.warehouseID),
                budgetCodeID: parseInt(IDdata?.budgetCodeID),
                statusID: parseInt(IDdata?.statusID),
            })

            setFromDate(new Date(IDdata.fromDate).toString());
            setToDate(new Date(IDdata?.toDate));
        }
        setIsIDDataForDefaultLoad(IDdata)
    }


    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getAllFactoriesByGroupID(requisitionSearchDetails.groupID);
        setFactories(factories);
    }

    async function GetWarehousesByGroupIDAndFactoryID() {
        var res = await services.GetWarehousesByGroupIDAndFactoryID(requisitionSearchDetails.groupID, requisitionSearchDetails.factoryID);
        setWarehouse(res);
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    async function getStatusDetails() {
        var response = await services.getStatusDetails();
        setStatusCodes(response);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    const generateFactoryDropDownMenu = (data) => {
        return data ? data.map(({ id, name }) => (
            <MenuItem key={id} value={id}>{name}</MenuItem>
        )) : [];
    };

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setRequisitionSearchDetails({
            ...requisitionSearchDetails,
            [e.target.name]: value
        });
        setIsShowTable(false);
    }
    let encrypted = "";
    const handleClickEdit = (requisitionID) => {
        encrypted = btoa(requisitionID.toString());
        let model = {
            groupID: parseInt(requisitionSearchDetails.groupID),
            factoryID: parseInt(requisitionSearchDetails.factoryID),
            warehouseID: parseInt(requisitionSearchDetails.warehouseID),
            budgetCodeID: parseInt(requisitionSearchDetails.budgetCodeID),
            statusID: parseInt(requisitionSearchDetails.statusID),
            fromDate: fromDate,
            toDate: toDate,
        }
        sessionStorage.setItem('Requisition-listing-page-search-parameters-id', JSON.stringify(model));
        navigate('/app/itemRequisition/addEdit/' + encrypted);
    }

    async function getRequisitionDetails() {
        let model = {
            groupID: parseInt(requisitionSearchDetails.groupID),
            factoryID: parseInt(requisitionSearchDetails.factoryID),
            warehouseID: parseInt(requisitionSearchDetails.warehouseID),
            budgetCodeID: parseInt(requisitionSearchDetails.budgetCodeID),
            requisitionStatus: parseInt(requisitionSearchDetails.statusID),
            fromDate: moment(fromDate.toString()).format('').split('T')[0],
            toDate: moment(toDate.toString()).format('').split('T')[0]
        }
        const response = await services.getRequisitionDetails(model);
        if (response.statusCode == 'Success') {
            setTableData(response.data);
            setIsShowTable(true);
        }
        else {
            alert.error(response.message)
        }
        setIsIDDataForDefaultLoad(null);
        setIsInitialLoadScreen(true);
    }

    const flattenTableData = () => {
        let flatData = [];
        tableData.forEach(grp => {
            grp.requisitions.forEach(req => {
                flatData.push({
                    ...req,
                    factoryName: grp.factoryName
                });
            });
        });
        return flatData;
    };

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add Requisition"}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title="View Requisition"
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: requisitionSearchDetails.groupID,
                            factoryID: requisitionSearchDetails.factoryID,
                            warehouseID: requisitionSearchDetails.warehouseID,
                            budgetCodeID: requisitionSearchDetails.budgetCodeID,
                            statusID: requisitionSearchDetails.statusID,
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory required').min("1", 'Factory is required')
                            })
                        }
                        onSubmit={() => trackPromise(getRequisitionDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleSubmit,
                            touched,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle("View Requisition")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionSearchDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionSearchDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--All Factories--</MenuItem>
                                                            {generateFactoryDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={requisitionSearchDetails.budgetCodeID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--All Account Codes--</MenuItem>
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="statusID">
                                                            Status
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.statusID && errors.statusID)}
                                                            fullWidth
                                                            helperText={touched.statusID && errors.statusID}
                                                            size='small'
                                                            name="statusID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={requisitionSearchDetails.statusID}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="0">--Select Status--</MenuItem>
                                                            {generateDropDownMenu(statusCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="fromDate" style={{ marginBottom: '-8px' }}>
                                                            From Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="fromDate"
                                                                value={fromDate}
                                                                onChange={(e) => {
                                                                    setFromDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="toDate" style={{ marginBottom: '-8px' }}>
                                                            To Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="toDate"
                                                                value={toDate}
                                                                onChange={(e) => {
                                                                    setToDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            <Box minWidth={1050}>
                                                {isShowTable && flattenTableData().length > 0 ? (
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            {
                                                                title: 'Factory',
                                                                field: 'factoryName',
                                                                type: 'string',
                                                                cellStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' }
                                                            },
                                                            {
                                                                title: 'Date',
                                                                field: 'requestDate',
                                                                type: 'date',
                                                                cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                                render: rowData => moment(rowData.requestDate).format('DD/MM/YYYY')
                                                            },
                                                            {
                                                                title: 'Requisition No.',
                                                                field: 'requisitionNumber',
                                                                type: 'string',
                                                                cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' }
                                                            },
                                                            {
                                                                title: 'Account Code',
                                                                field: 'budgetCode',
                                                                type: 'string',
                                                                cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' }
                                                            },
                                                            {
                                                                title: 'SKU Count',
                                                                field: 'skuCount',
                                                                type: 'numeric',
                                                                cellStyle: { textAlign: 'center', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'center', verticalAlign: 'middle' }
                                                            },
                                                            {
                                                                title: 'Quantity',
                                                                field: 'skuQuantity',
                                                                type: 'numeric',
                                                                cellStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                                                render: rowData =>
                                                                    rowData.skuQuantity != null
                                                                        ? rowData.skuQuantity.toLocaleString('en-US', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })
                                                                        : '-'
                                                            },
                                                            {
                                                                title: 'Status',
                                                                field: 'requisitionStatusName',
                                                                type: 'string',
                                                                cellStyle: { textAlign: 'center', paddingLeft: '10px', verticalAlign: 'middle' },
                                                                headerStyle: { textAlign: 'center', paddingLeft: '40px', verticalAlign: 'middle' },
                                                                render: rowData => {
                                                                    const getStatusConfig = (status) => {
                                                                        const configs = {
                                                                            'Quotation Called': {
                                                                                bg: '#fff3e0',
                                                                                color: '#e65100',
                                                                                border: '#ffe0b2'
                                                                            },
                                                                            'Quotation Complete': {
                                                                                bg: '#e3f2fd',
                                                                                color: '#1565c0',
                                                                                border: '#bbdefb'
                                                                            },
                                                                            'Factory Approved': {
                                                                                bg: '#e8f5e9',
                                                                                color: '#2e7d32',
                                                                                border: '#c8e6c9'
                                                                            },
                                                                            'Factory Reject': {
                                                                                bg: '#ffebee',
                                                                                color: '#c62828',
                                                                                border: '#ffcdd2'
                                                                            },
                                                                            'New Requisition': {
                                                                                bg: '#f5f5f5',
                                                                                color: '#616161',
                                                                                border: '#e0e0e0'
                                                                            },
                                                                            'Send to Approve': {
                                                                                bg: '#f3e5f5',
                                                                                color: '#6a1b9a',
                                                                                border: '#e1bee7'
                                                                            }
                                                                        };
                                                                        return configs[status] || configs['New Requisition'];
                                                                    };

                                                                    const config = getStatusConfig(rowData.requisitionStatusName);

                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                display: 'inline-block',
                                                                                backgroundColor: config.bg,
                                                                                color: config.color,
                                                                                padding: '4px 10px',
                                                                                borderRadius: '50px',
                                                                                fontWeight: '600',
                                                                                fontSize: '14px',
                                                                                border: `2px solid ${config.border}`,
                                                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
                                                                                transition: 'all 0.2s ease',
                                                                                cursor: 'default',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {rowData.requisitionStatusName}
                                                                        </div>
                                                                    );
                                                                }
                                                            }
                                                        ]}
                                                        data={flattenTableData()}
                                                        actions={[
                                                            {
                                                                icon: () => <EditIcon />,
                                                                tooltip: 'Edit',
                                                                onClick: (event, rowData) => handleClickEdit(rowData.requisitionID)
                                                            }
                                                        ]}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { height: '1%' },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1,
                                                            pageSize: 10,
                                                            grouping: false
                                                        }}
                                                    />
                                                ) : null}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment>
    )
}